import React from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../common/PrimaryButton";
import SecondaryButton from "../common/SecondaryButton";

function CTASection() {
  const navigate = useNavigate();

  return (
    <section
      style={{
        position: "relative",
        overflow: "hidden",
        background:
          "linear-gradient(180deg,#00152d 0%, #002147 100%)",
        padding: "70px 24px",
        textAlign: "center",
        borderRadius: "32px",
        margin: "60px 24px"
      }}
    >
      {/* Glow */}

      <div
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: "rgba(33,181,115,.10)",
          filter: "blur(100px)",
          top: "-120px",
          right: "-80px"
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 2,
          maxWidth: "700px",
          margin: "0 auto"
        }}
      >
        <span
          style={{
            color: "#21b573",
            fontSize: ".8rem",
            fontWeight: 700,
            letterSpacing: "1px",
            textTransform: "uppercase"
          }}
        >
          Ready To Accelerate Growth?
        </span>

        <h2
          style={{
            color: "#fff",
            fontSize: "clamp(2rem,4vw,3.2rem)",
            lineHeight: 1.1,
            marginTop: "16px",
            marginBottom: "18px",
            fontWeight: 700
          }}
        >
          Let's Talk About What's Next.
        </h2>

        <p
          style={{
            color: "rgba(255,255,255,.72)",
            maxWidth: "520px",
            margin: "0 auto 32px",
            lineHeight: 1.7
          }}
        >
          Discover opportunities to improve visibility,
          generate qualified demand and scale with confidence.
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "14px",
            flexWrap: "wrap"
          }}
        >
          <PrimaryButton
            onClick={() => navigate("/contact")}
          >
            Book Strategy Call
          </PrimaryButton>

          <SecondaryButton
            onClick={() =>
              navigate("/free-growth-audit")
            }
            style={{
              color: "#fff",
              border: "1px solid rgba(255,255,255,.20)",
              background: "transparent"
            }}
          >
            Free Growth Audit
          </SecondaryButton>
        </div>
      </div>
    </section>
  );
}

export default CTASection;